import { ProjectModel } from '@/pigeonline/wrapper';

export default class PigeonDocCollection extends ProjectModel {
  constructor(data = {}) {
    super(data);

    this.name = null;
    this._docs = [];
    this.docIds = [];
    this.saveDoc = null;
    this.loadDoc = null;

    //initialize props
    this.setProps(data);
  }

  static PROJECT_TYPE() {
    return 'pigeondoc_collection';
  }

  setProps(data) {
    ProjectModel.prototype.setProps.call(this, data);
  }

  set docs(docs) {
    this._docs = docs;
    // this.docIds = this.docs.map(doc => doc.id)
    this.docIds = docs;
  }

  get docs() {
    return this._docs;
  }

  add() {
    this._docs.push(...arguments);
    this.docIds = this._docs.map((doc) => doc.id);
  }

  toJSON() {
    const obj = { ...this };
    obj._docs = [];
    return obj;
  }
}
